import DialogModal from '@/components/DialogModal';

type Props = {
  isOpen: boolean;
  onCloseConfirmationModal: () => void;
  setResolveConfirmPromise: React.Dispatch<React.SetStateAction<((value: boolean) => void) | null>>;
};

const RecurringConfirmationModal = ({ isOpen, onCloseConfirmationModal, setResolveConfirmPromise }: Props) => {
  return (
    <DialogModal
      isOpen={isOpen}
      title="Edit Recurring Action"
      message="Editing this action will update all recurring actions in this series, are you sure you want to make this change?"
      onCancel={() => {
        setResolveConfirmPromise?.((resolve: any) => {
          if (resolve && typeof resolve === 'function') {
            resolve(false);
          }
        });
        onCloseConfirmationModal();
      }}
      onConfirm={() => {
        setResolveConfirmPromise?.((resolve: any) => {
          if (resolve && typeof resolve === 'function') {
            resolve(true);
          }
        });
        onCloseConfirmationModal();
      }}
      confirmVariant="danger"
      confirmText="Confirm"
    />
  );
};

export default RecurringConfirmationModal;
